import ApplicationController from '../../support/application_controller'
import ScrollToErrorMixin    from '../../support/scroll_to_error_mixin'
import mixin                 from '../../support/mixin'

export default class extends mixin(ApplicationController, ScrollToErrorMixin) {}
